const CptName = 'ComIframe'
function formatData (node) {
  console.dir(node);
  const {width, height} = clacImgWH.call(this, node)
  return {
    data: {
      html: node.outerHTML,
      width,
      height,
      src: node.src
    },
    cpt: CptName
  }
}

function clacImgWH (node) {
  let width = node.getAttribute('width'),
    height = node.getAttribute('height')
  if (width && height) {
    let dpi = height / width
    height = this.client_width * dpi
  } else {
    let getURL = window.URL || window.webkitURL || window.mozURL || window.msURL
    let url = new getURL(node.src)
    if (url.host == 'music.163.com') {      
      height = 86
    } else {
      height = 220
    }
  }
  node.setAttribute('width', this.client_width)
  node.setAttribute('height', height)
  return {
    width: this.client_width,
    height: height
  }
}


export default {
  install (Vue) {
    Vue.component(CptName, require('./index.vue').default)
    window.hb__format['iframe'] = formatData
  }
}